<template>
  <div>
    <b-dropdown
      variant="link"
      no-caret
      right
      boundary="viewport"
      @click.stop
    >
      <template #button-content>
        <feather-icon
          icon="MoreVerticalIcon"
          size="18"
          class="text-muted"
        />
      </template>
      <b-dropdown-item @click.stop="copyShareLink">
        <feather-icon
          icon="LinkIcon"
          class="mr-50"
        />
        {{ $t('Copy Link') }}
      </b-dropdown-item>
      <b-dropdown-item @click.stop="$emit('edit', task)">
        <feather-icon
          icon="EditIcon"
          class="mr-50"
        />
        {{ $t('Edit') }}
      </b-dropdown-item>
      <b-dropdown-item
        v-b-modal="`delete-${task.uuid}-confirm-modal`"
        variant="danger"
        @click.stop
      >
        <feather-icon
          icon="TrashIcon"
          class="mr-50"
        />
        {{ $t('Delete') }}
      </b-dropdown-item>
    </b-dropdown>

    <!-- Delete Confirmation Modal -->
    <b-modal
      :id="`delete-${task.uuid}-confirm-modal`"
      :title="$t('Delete Task')"
      hide-footer
      centered
    >
      <p>{{ $t('Are you sure you want to delete this task?') }}</p>
      <p class="text-danger">
        <strong>{{ task.title }}</strong>
      </p>
      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="mr-1"
          @click="$bvModal.hide(`delete-${task.uuid}-confirm-modal`)"
        >
          {{ $t('Cancel') }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="submitting"
          @click="deleteTask"
        >
          <b-spinner
            v-if="submitting"
            small
            class="mr-50"
          />
          {{ $t('Delete') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BDropdown, BDropdownItem, BModal, BButton, BSpinner,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    BSpinner,
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      submitting: false,
      linkCopied: false,
    }
  },
  methods: {
    ...mapActions('boards', ['deleteTask']),
    copyShareLink() {
      const { boardUid } = this.$route.params
      const taskUid = this.base58Converter(this.task?.uuid)

      const shareLink = `${window.location.origin}/project-management/board/${boardUid}/tasks/${taskUid}`
      navigator.clipboard.writeText(shareLink).then(() => {
        this.linkCopied = true
      })

      this.showSuccess(this.$t('Share link copied to clipboard!'))
    },
    async deleteTask() {
      this.submitting = true
      try {
        const result = await this.$store.dispatch('boards/deleteTask', this.task.uuid)
        this.showSuccess(result.message)

        this.$bvModal.hide(`delete-${this.task.uuid}-confirm-modal`)
        this.$emit('refresh')
      } catch (error) {
        this.showError(error.message)
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
